import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "home-content"
};
const _hoisted_2 = {
  id: "scenarios",
  class: "section scene-section"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "section-intro scene-heading"
};
const _hoisted_5 = {
  class: "scene-grid"
};
const _hoisted_6 = {
  class: "scene-art scene-art-hotel",
  "aria-hidden": "true"
};
import HomeCapabilities from '@/components/sections/HomeCapabilities.vue';
export default {
  __name: 'HomeContent',
  emits: ['trial'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _directive_reveal = _resolveDirective("reveal");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [_createElementVNode("div", null, [_createElementVNode("h2", null, "让智能睡眠融入不同场景")], -1), _createElementVNode("p", {
        class: "section-desc"
      }, " 从个人睡眠，到酒店服务与养老照护，把同一套睡眠感知与干预能力，放进不同的真实使用环境。 ", -1)]))), [[_directive_reveal]]), _createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
        class: "scene-card scene-card-large scene-home",
        to: "/scene"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("div", {
          class: "scene-art scene-art-home",
          "aria-hidden": "true"
        }, [_createElementVNode("span", {
          class: "window-line"
        }), _createElementVNode("span", {
          class: "bed-line bed-head"
        }), _createElementVNode("span", {
          class: "bed-line bed-body"
        }), _createElementVNode("span", {
          class: "bed-line bed-leg-a"
        }), _createElementVNode("span", {
          class: "bed-line bed-leg-b"
        }), _createElementVNode("span", {
          class: "moon"
        }), _createElementVNode("span", {
          class: "signal-mini signal-mini-a"
        }), _createElementVNode("span", {
          class: "signal-mini signal-mini-b"
        }), _createElementVNode("span", {
          class: "signal-mini signal-mini-c"
        })], -1), _createElementVNode("div", {
          class: "scene-overlay"
        }, null, -1), _createElementVNode("div", {
          class: "scene-content"
        }, [_createElementVNode("span", {
          class: "scene-no"
        }, "01 / HOME"), _createElementVNode("h3", null, "居家睡眠"), _createElementVNode("p", null, "把专业睡眠感知能力，转化为日常可持续使用的家庭体验。"), _createElementVNode("span", {
          class: "scene-link"
        }, [_createTextVNode("了解场景 "), _createElementVNode("i", null, "→")])], -1)])),
        _: 1
      })), [[_directive_reveal]]), _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        class: "scene-card scene-hotel",
        to: "/scene"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "hotel-building"
        }, null, -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, n => {
          return _createElementVNode("span", {
            key: n,
            class: "hotel-window"
          });
        }), 64)), _cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "hotel-ground"
        }, null, -1))]), _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "scene-overlay"
        }, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "scene-content"
        }, [_createElementVNode("span", {
          class: "scene-no"
        }, "02 / HOTEL"), _createElementVNode("h3", null, "酒店睡眠"), _createElementVNode("p", null, "为住宿场景提供差异化的睡眠体验与服务能力。"), _createElementVNode("span", {
          class: "scene-link"
        }, [_createTextVNode("了解场景 "), _createElementVNode("i", null, "→")])], -1))]),
        _: 1
      })), [[_directive_reveal, 90]]), _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        class: "scene-card scene-care",
        to: "/scene"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("div", {
          class: "scene-art scene-art-care",
          "aria-hidden": "true"
        }, [_createElementVNode("span", {
          class: "care-circle care-circle-one"
        }), _createElementVNode("span", {
          class: "care-circle care-circle-two"
        }), _createElementVNode("span", {
          class: "care-cross"
        }, [_createElementVNode("i"), _createElementVNode("b")]), _createElementVNode("span", {
          class: "care-wave"
        })], -1), _createElementVNode("div", {
          class: "scene-overlay"
        }, null, -1), _createElementVNode("div", {
          class: "scene-content"
        }, [_createElementVNode("span", {
          class: "scene-no"
        }, "03 / CARE"), _createElementVNode("h3", null, "养老机构"), _createElementVNode("p", null, "面向长者睡眠与健康管理需求，探索更自然的持续监测方式。"), _createElementVNode("span", {
          class: "scene-link"
        }, [_createTextVNode("了解场景 "), _createElementVNode("i", null, "→")])], -1)])),
        _: 1
      })), [[_directive_reveal, 180]])])])]), _createVNode(HomeCapabilities)]);
    };
  }
};